import { useQuery } from '@sequencehq/api'
import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import { MINUTES } from '@sequencehq/utils/dates'
import type { InvoiceDueDateCalculatedFrom } from 'Invoices/types'

export const useInvoiceDueDateTerms = (): {
  calculatedFrom: InvoiceDueDateCalculatedFrom | null | undefined
} => {
  const { data: calculatedFrom } = useQuery(
    dashboardv20240509Client.getInvoiceAccountingDateSettings,
    undefined,
    {
      select: data => data?.invoiceDueDateCalculatedFrom,
      staleTime: 5 * MINUTES
    }
  )

  return { calculatedFrom }
}
